<template>
    <div id="staffScanTemperatureWithStud">

        <!--        web view-->
        <div style="padding: 20px; background: #ffffff; text-align: left;" v-if="!checkMobileStatus">
            <img src="../assets/Vector24.png" />
            <span style="color: #536170; font-weight: 500; margin-left: 5px; display: inline-block;">Temperature Scan</span>
        </div>

        <div class="container" v-if="!checkMobileStatus">

            <div class="bluetooth-connect-container" style="text-align: left; margin-top: 30px; margin-bottom: 30px;">
                <span style="color: #4F4F4F; margin-bottom: 5px; display: block;">Connect to Thermometer Scanner</span>

                <div class="row" style="margin: 0px; padding: 20px; background: #ffffff; border-radius: 5px;">
                    <div style="width: 15%;">
                        <img src="../assets/tempC.png" v-if="thermometerStatus"
                             style="width: 80px; height: 80px; background: #E9EDF7; border-radius: 50%;" />
                        <img src="../assets/tempD.png" v-if="!thermometerStatus"
                             style="width: 80px; height: 80px; background: #E9EDF7; border-radius: 50%;" />
                    </div>

                    <div class="row" style="margin: 15px 0px; width: 80%;">
                        <div style="width: 80%;">
                            <label style="color: #536170; margin-bottom: 0px;" v-if="thermometerStatus">Thermometer Scanner is Connected</label>
                            <label style="color: #536170; margin-bottom: 0px;" v-if="!thermometerStatus">Thermometer Scanner is Disconnected</label>
                            <small style="color: #4F4F4F;">You may proceed to take temperature</small>
                        </div>

                        <div style="width: 15%;">
                            <el-switch v-model="thermometerStatus" @change="checkThermoStatus()"></el-switch>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row" style="margin: 0px;">
                <div style="width: 49%; display: none;">
                    <span style="color: #4F4F4F; display: block; text-align: left; margin-bottom: 5px;">Scan Student QR Code</span>

                    <div style="background: #ffffff; border-radius: 5px; padding: 40px; height: 300px; max-height: 300px;">
                        <div style="background: #E9EDF7; border-radius: 13px; height: 100%; position:relative;">
                            <img src="../assets/sample-qr.png"
                                 style="width: 100%; height: 100%; position: absolute; opacity: 0.1; top: 0px; left: 0px;"/>
                            <span style="color: #5C6B77; display: inline-block; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
                                Connect to a Camera
                            </span>
<!--                            <qrcode-stream @decode="onDecode" @init="onInit"></qrcode-stream>-->
                        </div>
                    </div>
                </div>

                <div style="width: 100%;">
                    <span style="color: #4F4F4F; display: block; text-align: left; margin-bottom: 5px;">Search Student Manually</span>

                    <!-- height: 400px; max-height: 400px; -->
                    <div style="background: #ffffff; border-radius: 5px; padding: 20px;">
                        <span style="color: #4F4F4F; display: block; font-size: 12px; margin-bottom: 15px;">If scan barcode fail, can manually choose student</span>

                        <div style="width: 100%; display: none;">
                            <input class="form-control student-search" type="text" v-on:keyup="searchStudent()" v-model="searchValue"
                                   placeholder="Search Student" title="Search Student" style="background: #F8FAFF; border: 1px solid #EEEEEE; border-radius: 5px;">

                            <div class="student-list-container" style="margin-top: 20px; overflow: auto; width: 100%; max-height: 165px;">
                                <div class="student-each-container" v-for="studList in filterAllStudentList"
                                     v-if="filterAllStudentList.length > 0" @click="changeStudent(studList.Index_No)">
                                    <span>{{studList.First_Name + studList.Middle_Name + studList.Last_Name}}</span>
                                </div>

                                <div v-if="filterAllStudentList.length <= 0">
                                    <span>Empty List</span>
                                </div>
                            </div>
                        </div>

                        <div style="width: 100%;">
                            <!-- max-height: 300px; -->
                            <div class="student-list-container" style="margin-top: 20px; overflow: auto; width: 100%;">
                                <div class="" style="text-align: left; border-bottom: 1px solid #D3D9E8; padding: 5px;"
                                     v-for="tempobj_Year of groupAllStudentList" :key="tempobj_Year.id"
                                     v-if="groupAllStudentList.length > 0">
                                    <div>
                                        <label>Year - {{tempobj_Year.Str_Display}}</label>

                                        <div style="display: none;"
                                             v-if="tempobj_Year.ArrObj_Items.length > 0"
                                             v-for="tempobj_Level of tempobj_Year.ArrObj_Items">
                                            <label>Level - {{tempobj_Level.Str_Display}}</label>

                                            <div v-if="tempobj_Level.ArrObj_Items.length > 0" v-for="tempobj_Class of tempobj_Level.ArrObj_Items">
                                                <label>Class - {{tempobj_Class.Str_Display}}</label>

                                                <div class="row student-tag">
                                                    <div class="div_Student uncheck"
                                                         v-for="tempobj_Student of tempobj_Class.ArrObj_Items"
                                                         :key="tempobj_Student.id">
                                                        <label class="text-center" style="cursor: pointer;"
                                                               @click="changeStudent(tempobj_Student.Index_No)"
                                                               :for="tempobj_Student.Student_ID">
                                                            <img class="student" :src="getSource(tempobj_Student)"/>
                                                            <br/>
                                                            <span>{{tempobj_Student.First_Name.split(" ")[0]}}</span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="" v-for="tempobj_Level of tempobj_Year.ArrObj_Items"
                                             :key="tempobj_Level.id">
                                            <header class="" role="tab">
                                                <div class="row">
                                                    <div class="col-12 sub-tag">
                                                        <div v-b-toggle="replaceStringSpace(tempobj_Level.Str_SortBy)" class="sub-tag__child">
                                                            <span>{{tempobj_Level.Str_Display}}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </header>

                                            <b-collapse :id="replaceStringSpace(tempobj_Level.Str_SortBy)" accordion="level" role="tabpanel">
                                                <div>
                                                    <div class="" v-for="tempobj_Class of tempobj_Level.ArrObj_Items"
                                                         :key="tempobj_Class.id">
                                                        <header class="" role="tab">
                                                            <div class="row">
                                                                <div class="col-12 sub-tag option-tag">
                                                                    <div v-b-toggle="(tempobj_Level.Str_SortBy + tempobj_Class.Str_SortBy).replace(/ /g, '_')"
                                                                         :class="'sub-tag__child'">
                                                                        <span>{{tempobj_Class.Str_Display}}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </header>
                                                        <b-collapse
                                                                :id="(tempobj_Level.Str_SortBy + tempobj_Class.Str_SortBy).replace(/ /g, '_')"
                                                                accordion="class"
                                                                role="tabpanel">
                                                            <div>
                                                                <div class="row student-tag">
                                                                    <div class="div_Student uncheck"
                                                                         v-for="tempobj_Student of tempobj_Class.ArrObj_Items"
                                                                         :key="tempobj_Student.id">

                                                                        <div v-for="tempStud in allStudentList"
                                                                             v-if="tempStud.Index_No === tempobj_Student.Index_No && tempStud.tempIn"
                                                                             style="position: absolute; top: -10px; font-size: 12px; width: 100%; text-align: center;">
                                                                            <span style="display: block;">Time : {{tempStud.timeTempIn}}</span>
                                                                            <span>Temperature : {{tempStud.tempIn}}</span>
                                                                        </div>

                                                                        <label class="text-center" style="cursor: pointer;"
                                                                               @click="changeStudent(tempobj_Student.Index_No)"
                                                                               :for="tempobj_Student.Student_ID">
                                                                            <img class="student" :src="getSource(tempobj_Student)"/>
                                                                            <br/>
                                                                            <span>{{tempobj_Student.First_Name.split(" ")[0]}}</span>
                                                                        </label>
                                                                    </div>

                                                                    <!-- <div v-if="!arr_ClassName.includes(tempobj_Class.Str_Display.toString().trim())">{{emptyStudentMsg}}</div>-->
                                                                </div>
                                                            </div>
                                                        </b-collapse>
                                                    </div>
                                                </div>
                                            </b-collapse>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="groupAllStudentList.length <= 0">
                                    <span>Empty List</span>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <!--        ok-only-->
            <b-modal id="modal_ScanDetails" title="Student details" ref="modal_ScanDetails" centered
                     :ok-title="lang('SAVE')" @ok="saveStudTemp" :cancel-title="lang('CLOSE')">
                <div style="text-align: left; padding: 20px;">

                    <div class="row" style="margin: 0px;">
                        <div style="width: 48%;">
                            <label>Student Name</label>
                            <input type="text" disabled="disabled" v-model="studName" class="form-control"
                                   style="width: 100%; background: #E9EDF7; color: #222222;" />
                        </div>

                        <div style="width: 48%; margin-left: auto;">
                            <label>Student ID</label>
                            <input type="text" disabled="disabled" v-model="studID" class="form-control"
                                   style="width: 100%; background: #E9EDF7; color: #222222;" />
                        </div>
                    </div>

                    <div class="row" style="margin: 0px;">
                        <div style="width: 48%;">
                            <label>In or Out</label>
                            <select v-model="userType" class="form-control" style="width: 100%; background: #F8FAFF;">
                                <option value="IN">In</option>
                                <option value="OUT">Out</option>
                            </select>
                        </div>

                        <div style="width: 48%; margin-left: auto;">
                            <label>Temperature Reading (If manually input, press Enter to Remark)</label>
                            <input v-model="studTemp" @keypress="onlyNumber($event)" class="form-control" style="width: 100%; background: #F8FAFF;" />
                        </div>
                    </div>

                    <div>
                        <label>Remark</label>
                        <!--                    <input v-model="studRemark" class="form-control" style="width: 100%;" />-->
                        <textarea rows="4" v-model="studRemark" class="form-control" style="width: 100%; resize: none;"></textarea>
                    </div>

                </div>
            </b-modal>
        </div>

        <!--        mobile view-->
        <div style="padding: 20px; background: #413f56; text-align: left; " v-if="checkMobileStatus">
            <span style="font-weight: 500; display: inline-block; color: #ffffff;">Temperature Scan</span>
        </div>

        <div :class="screenWidth > 760 ? 'sct-ipad' : 'sct-mobile'" v-if="checkMobileStatus" style="position:relative;">
            <div style="padding: 0px 20px;">
                <div class="bluetooth-connect-container" style="text-align: left; margin-top: 30px;">
                    <span style="color: #4F4F4F; margin-bottom:10px; display: block;">Connect to Thermometer Scanner</span>

                    <div class="row" style="margin: 0px; padding: 20px; background: #ffffff; border-radius: 5px; align-items: center; justify-content: center;">
                        <div style="width: 20%;">
                            <img src="../assets/tempC.png" v-if="thermometerStatus"
                                 style="width: 60px; height: 60px; background: #E9EDF7; border-radius: 50%;" />
                            <img src="../assets/tempD.png" v-if="!thermometerStatus"
                                 style="width: 60px; height: 60px; background: #E9EDF7; border-radius: 50%;" />
                        </div>

                        <div class="row" style="margin: 15px 0px 15px auto; width: 78%;">
                            <div style="width: 80%;">
                                <label style="color: #536170; margin-bottom: 0px;" v-if="thermometerStatus">Thermometer Scanner is Connected</label>
                                <label style="color: #536170; margin-bottom: 0px;" v-if="!thermometerStatus">Thermometer Scanner is Disconnected</label>
                                <small style="color: #4F4F4F;">You may proceed to take temperature</small>
                            </div>

                            <div style="width: 15%;">
                                <el-switch v-model="thermometerStatus" @change="checkThermoStatus()"></el-switch>
                            </div>
                        </div>
                    </div>
                </div>

                <div style="width: 100%; display: none;">
                    <span style="color: #4F4F4F; display: block; text-align: left; margin-bottom: 10px;">Scan Student QR Code</span>

                    <div style="background: #ffffff; border-radius: 5px; padding: 40px; height: 300px; max-height: 300px;">
                        <div style="background: #E9EDF7; border-radius: 13px; height: 100%; position:relative;">
                            <img src="../assets/sample-qr.png"
                                 style="width: 100%; height: 100%; position: absolute; opacity: 0.1; top: 0px; left: 0px;"/>
                            <span style="color: #5C6B77; display: inline-block; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
                                Connect to a Camera
                            </span>
<!--                            <qrcode-stream @decode="onDecode" @init="onInit"></qrcode-stream>-->
                        </div>
                    </div>
                </div>
            </div>

            <div style="position: relative; bottom: -53px; display: none;" v-if="isSearch">
                <div style="background: #ffffff; border-radius: 5px; padding: 20px; height: 300px; max-height: 300px; text-align: left;">
                    <span style="color: #4F4F4F; display: block; margin-bottom: 10px;">Search Student Manually</span>

                    <span style="color: #4F4F4F; display: block; font-size: 12px; margin-bottom: 15px;">If scan barcode fail, can manually choose student</span>

                    <div style="width: 100%;">
                        <input class="form-control student-search" type="text" v-on:keyup="searchStudent()" v-model="searchValue"
                               placeholder="Search Student" title="Search Student" style="background: #F8FAFF; border: 1px solid #EEEEEE; border-radius: 5px;">

                        <div class="student-list-container" style="margin-top: 20px; overflow: auto; width: 100%; max-height: 165px;">
                            <div class="student-each-container" v-for="studList in filterAllStudentList"
                                 v-if="filterAllStudentList.length > 0" @click="changeStudent(studList.Index_No)">
                                <span>{{studList.First_Name + studList.Middle_Name + studList.Last_Name}}</span>
                            </div>

                            <div v-if="filterAllStudentList.length <= 0">
                                <span>Empty List</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div style="position: relative; bottom: -53px;">
                <!-- max-height: 400px; -->
                <div class="student-list-container" style="margin-top: 20px; overflow: auto; width: 100%; ">
                    <div class="" style="text-align: left; border-bottom: 1px solid #D3D9E8; padding: 5px;"
                         v-for="tempobj_Year of groupAllStudentList" :key="tempobj_Year.id"
                         v-if="groupAllStudentList.length > 0">
                        <div>
                            <label>Year - {{tempobj_Year.Str_Display}}</label>

                            <div class="" v-for="tempobj_Level of tempobj_Year.ArrObj_Items"
                                 :key="tempobj_Level.id">
                                <header class="" role="tab">
                                    <div class="row">
                                        <div class="col-12 sub-tag">
                                            <div v-b-toggle="replaceStringSpace(tempobj_Level.Str_SortBy)" class="sub-tag__child">
                                                <span>{{tempobj_Level.Str_Display}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </header>

                                <b-collapse :id="replaceStringSpace(tempobj_Level.Str_SortBy)" accordion="level" role="tabpanel">
                                    <div>
                                        <div class="" v-for="tempobj_Class of tempobj_Level.ArrObj_Items"
                                             :key="tempobj_Class.id">
                                            <header class="" role="tab">
                                                <div class="row">
                                                    <div class="col-12 sub-tag option-tag">
                                                        <div v-b-toggle="(tempobj_Level.Str_SortBy + tempobj_Class.Str_SortBy).replace(/ /g, '_')"
                                                             :class="'sub-tag__child'">
                                                            <span>{{tempobj_Class.Str_Display}}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </header>
                                            <b-collapse
                                                    :id="(tempobj_Level.Str_SortBy + tempobj_Class.Str_SortBy).replace(/ /g, '_')"
                                                    accordion="class"
                                                    role="tabpanel">
                                                <div>
                                                    <div class="row student-tag">
                                                        <div class="div_Student uncheck"
                                                             v-for="tempobj_Student of tempobj_Class.ArrObj_Items"
                                                             :key="tempobj_Student.id">

                                                            <div v-for="tempStud in allStudentList"
                                                                 v-if="tempStud.Index_No === tempobj_Student.Index_No && tempStud.tempIn"
                                                                 style="position: absolute; top: -10px; font-size: 14px;">
                                                                <span style="display: block;">Time : {{tempStud.timeTempIn}}</span>
                                                                <span>Temperature : {{tempStud.tempIn}}</span>
                                                            </div>

                                                            <label class="text-center" style="cursor: pointer;"
                                                                   @click="changeStudent(tempobj_Student.Index_No)"
                                                                   :for="tempobj_Student.Student_ID">
                                                                <img class="student" :src="getSource(tempobj_Student)"/>
                                                                <br/>
                                                                <span>{{tempobj_Student.First_Name.split(" ")[0]}}</span>
                                                            </label>
                                                        </div>

                                                        <!-- <div v-if="!arr_ClassName.includes(tempobj_Class.Str_Display.toString().trim())">{{emptyStudentMsg}}</div>-->
                                                    </div>
                                                </div>
                                            </b-collapse>
                                        </div>
                                    </div>
                                </b-collapse>
                            </div>
                        </div>
                    </div>

                    <div v-if="groupAllStudentList.length <= 0">
                        <span>Empty List</span>
                    </div>
                </div>
            </div>

            <!--        ok-only-->
            <b-modal id="modal_ScanDetails" title="Student details" ref="modal_ScanDetails" centered
                     :ok-title="lang('SAVE')" @ok="saveStudTemp" :cancel-title="lang('CLOSE')">
                <div style="text-align: left; padding: 20px;">

                    <div class="row" style="margin: 0px;">
                        <div style="width: 100%;">
                            <label>Student Name</label>
                            <input type="text" disabled="disabled" v-model="studName" class="form-control"
                                   style="width: 100%; background: #E9EDF7; color: #222222;" />
                        </div>

                        <div style="width: 100%;">
                            <label>Student ID</label>
                            <input type="text" disabled="disabled" v-model="studID" class="form-control"
                                   style="width: 100%; background: #E9EDF7; color: #222222;" />
                        </div>
                    </div>

                    <div class="row" style="margin: 0px;">
                        <div style="width: 100%;">
                            <label>In or Out</label>
                            <select v-model="userType" class="form-control" style="width: 100%; background: #F8FAFF;">
                                <option value="IN">In</option>
                                <option value="OUT">Out</option>
                            </select>
                        </div>

                        <div style="width: 100%;">
                            <label>Temperature Reading (If manually input, press Enter to Remark)</label>
                            <input v-model="studTemp" @keypress="onlyNumber($event)" class="form-control" style="width: 100%; background: #F8FAFF;" />
                        </div>
                    </div>

                    <div>
                        <label>Remark</label>
                        <!--                    <input v-model="studRemark" class="form-control" style="width: 100%;" />-->
                        <textarea rows="4" v-model="studRemark" class="form-control" style="width: 100%; resize: none;"></textarea>
                    </div>

                </div>
            </b-modal>
        </div>

        <!--        unuse (should be can delete)-->
        <div>
            <div class="" style="text-align: left; width: 100%; padding: 15px; display: none;">
                <label>
                    <!--                    {{devicesStatusMsg}}-->
                    Thermometer Scanner is
                    <select v-model="thermometerStatus" @change="checkThermoStatus()">
                        <option value="connect">connect</option>
                        <option value="disconnect">disconnect</option>
                    </select>
                </label>
                <!--                <input class="btn btn-primary" type="submit" value="Connect"-->
                <!--                       @click="getDevices" style="display: inline-block;" />-->
                <!--                <input class="btn btn-primary" type="submit" value="Disconnect"-->
                <!--                       @click="onDisconnectButtonClick()" style="display: inline-block;" />-->
            </div>
        </div>

        <div style="text-align: left; width: 100%; padding: 15px; display: none;">
            <div>

                <!--                <div style="width: 100%;">-->
                <!--                    <input class="btn btn-primary" type="submit" value="Start"-->
                <!--                           @click="triggerStartScan" style="display: inline-block;" />-->
                <!--                    <input class="btn btn-primary" type="submit" value="Stop"-->
                <!--                           @click="triggerStopScan" style="display: inline-block;" />-->
                <!--                </div>-->

                <!--                <label>-->
                <!--                    <select v-model="barcodeStatus" @change="checkBarcodeStatus()" style="margin-right: 10px;">-->
                <!--                        <option value="start">Start</option>-->
                <!--                        <option value="stop">Stop</option>-->
                <!--                    </select>-->

                <!--                    <span>Camera</span>-->
                <!--                    <select name="input-stream_constraints" id="deviceSelection">-->
                <!--                    </select>-->
                <!--                </label>-->

                <div v-if="allStudentList.length > 0" style="margin-top: 20px;">
                    <label>Select Student (* If scan barcode fail, can manually choose student)</label>
                    <select v-model="selectedStudent" class="form-control" @change="changeStudent()">
                        <option v-for="studList in allStudentList" :value="studList.Index_No">
                            {{studList.First_Name + studList.Middle_Name + studList.Last_Name}}
                        </option>
                    </select>
                </div>

                <!--                <div id="interactive" class="viewport" style="width: 100%;">-->
                <!--                </div>-->
                <!--                <qrcode-stream @decode="onDecode" @init="onInit" />-->
                <!--                <qrcode-stream @decode="onDecode" @init="onInit"></qrcode-stream>-->
            </div>
        </div>

        <div style="text-align: left; padding: 20px; display: none;">
            <div>
                <label>In or Out</label>
                <select v-model="userType" class="form-control" style="width: 100%;">
                    <option value="IN">In</option>
                    <option value="OUT">Out</option>
                </select>
            </div>

            <div>
                <label>Student ID</label>
                <input type="text" disabled="disabled" v-model="studID" class="form-control" style="width: 100%; background: #ffffff;" />
            </div>

            <div>
                <label>Student Name</label>
                <input type="text" disabled="disabled" v-model="studName" class="form-control" style="width: 100%; background: #ffffff;" />
            </div>

            <div>
                <label>Temperature Reading (If manually input, press Enter to Remark)</label>
                <input v-model="studTemp" @keypress="onlyNumber($event)" class="form-control" style="width: 100%;" />
                <!--                <textarea rows="5" class="form-control" style="width: 100%;" v-model="studTemp" @keypress="onlyNumber($event)">{{studTemp}}</textarea>-->
            </div>
        </div>

        <div class="test container" style="display: none;">
            <h1 class="text-primary">{{title}}</h1>
            <p class="text-warning">v{{version}}</p>
            <div class="" style="text-align: left; width: 100%; padding: 15px;">
                <label>{{devicesStatusMsg}}</label>
                <input class="btn btn-primary" type="submit" value="Connect"
                       @click="getDevices" style="display: inline-block;" />
                <input class="btn btn-primary" type="submit" value="Disconnect"
                       @click="onDisconnectButtonClick()" style="display: inline-block; margin-left: 20px;" />
            </div>
            <br>
            <div id="output-panel" class="panel panel-default">
                <div class="panel-heading">
                    Output
                </div>
                <div id="output" class="panel-body">
                    <div id="content"></div>
                    <div id="status" class="text-danger"></div>
                    <pre id="log" style="text-align:left"></pre>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DataSource from "../data/datasource";
    import $ from 'jquery';
    import {lang} from '../locale/index';
    import moment from 'moment';

    import Quagga from 'quagga'; // ES6
    import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from 'vue-qrcode-reader';

    export default {
        name: "StaffScanTemperatureWithStud",
        components: {
            QrcodeStream,
        },
        data() {
            return {
                bluetoothDevice: '',
                title: 'Scanner',
                user: {
                    firstName: 'Nick',
                    lastName: 'Tsilivis'
                },
                message: '',
                version: '0.0.1',
                devicesStatusMsg: 'Thermometer Scanner is disconnect!',

                userType: "IN",
                studID: "",
                studName: "",
                studTemp: "",
                studRemark: "",
                scanStudIndex: "",
                allStudentList: [],
                filterAllStudentList: [],
                selectedStudent: "",

                thermometerStatus: false,
                barcodeStatus: "",
                searchValue: "",
                checkMobileStatus: false,
                isSearch: false,

                groupAllStudentList: [],
                arrobj_SelectedStudents: [],
                screenWidth: "",

                myCharacteristic: "",
            };
        },
        props: [],
        async created() {
            // await window.addEventListener("load", this.onWindowLoad);
            await window.addEventListener('resize', this.isMobile);
            await this.getAllStudent();
            // await this.sortByLevelClass();
        },
        async mounted() {
            this.isMobile();

            if (!navigator.bluetooth) {
                // this.setStatus('Web Bluetooth API is not available.\n');
                // alert("Encoded Message: " + encoder.encode("Makis"));

                this.$notify.error({
                    title: lang('Error'),
                    message: "Web Bluetooth API is not available"
                });
            }
        },
        methods: {
            lang,

            startDevicesNotif() {
                if (navigator.bluetooth) {
                    let serviceUuid = "0000fe18-0000-1000-8000-00805f9b34fb";

                    let characteristicUuid = "0000fe10-0000-1000-8000-00805f9b34fb";

                    navigator.bluetooth.requestDevice({filters: [{services: [serviceUuid]}]})
                    .then(device => {
                        console.log('Connecting to GATT Server...');
                        return device.gatt.connect();
                    })
                    .then(server => {
                        console.log('Getting Service...');
                        return server.getPrimaryService(serviceUuid);
                    })
                    .then(service => {
                        console.log('Getting Characteristic...');
                        return service.getCharacteristic(characteristicUuid);
                    })
                    .then(characteristic => {
                        this.myCharacteristic = characteristic;
                        return this.myCharacteristic.startNotifications().then(_ => {
                            console.log('> Notifications started');
                            this.myCharacteristic.addEventListener('characteristicvaluechanged',
                                this.handleNotifications);
                        });
                    })
                    .catch(error => {
                        console.log('Argh! ' + error);
                    });
                }
            },

            stopDevicesNotif() {
                if (this.myCharacteristic) {
                    this.myCharacteristic.stopNotifications()
                    .then(_ => {
                        console.log('> Notifications stopped');
                        this.myCharacteristic.removeEventListener('characteristicvaluechanged',
                            this.handleNotifications);
                    })
                    .catch(error => {
                        console.log('Argh! ' + error);
                    });
                }
            },

            getDevices(e) {
                // e.preventDefault();

                this.clearLog();

                if (navigator.bluetooth) {
                    var myCharacteristic;
                    var bluetoothDevice;

                    let filters = [];

                    // let serviceUuid = document.querySelector('#service').value;
                    let serviceUuid = "0000fe18-0000-1000-8000-00805f9b34fb";
                    // this.log('Service UUID: ' + serviceUuid);

                    let characteristicUuid = "0000fe10-0000-1000-8000-00805f9b34fb";

                    // let message = document.querySelector('#message').value;

                    // this.log('Characteristic UUID: ' + characteristicUuid);

                    this.log('Requesting Bluetooth Device...');
                    // bluetoothDevice.gatt.disconnect();

                    navigator.bluetooth.requestDevice({
                        // filters:[
                        //     {namePrefix:'JXB'},
                        //     {services:['0000fe18-0000-1000-8000-00805f9b34fb']}
                        // ],
                        acceptAllDevices: true
                    })
                        .then(device => {

                            bluetoothDevice = device;
                            this.bluetoothDevice = device;

                            this.log('-> Name:      ' + device.name);
                            this.log('-> ID:        ' + device.id);
                            console.log(device);

                            bluetoothDevice.addEventListener('gattserverdisconnected', this.onDisconnected);
                            return this.connectDevices();
                            // return device.gatt.connect();
                        })
                        .then(server =>{
                            // this.log('Getting Service');
                            return server.getPrimaryService(serviceUuid);
                        })
                        .then(service => {
                            // this.log('Getting characteristic');
                            if (characteristicUuid) {
                                return service.getCharacteristic(characteristicUuid);
                            }
                        })
                        .then(characteristic => {
                            myCharacteristic = characteristic;
                            return myCharacteristic.startNotifications().then(_ => {
                                this.log('> Notifications started');
                                myCharacteristic.addEventListener('characteristicvaluechanged',
                                    this.handleNotifications);
                            });
                        })
                        .then(_ => {
                            this.log("Message successfully sent !");
                            this.devicesStatusMsg = "Thermometer Scanner is connected!";
                        })
                        // .then(characteristics => {
                        //   console.log(characteristics);
                        //   this.log('> Characteristics: ' + characteristics.map(c => c.uuid).join('\n' + ' '.repeat(19)));
                        // })
                        .catch(error => {
                            this.log('Error: ' + error);
                        });
                }
                else {
                    alert('No Bluetooth detected');
                }
            },
            handleNotifications(event) {
                let value = event.target.value;
                if(value.byteLength == 15)
                {
                    // console.log(value);
                    let a = [];
                    // Convert raw data bytes to hex values just for the sake of showing something.
                    // In the "real" world, you'd use data.getUint8, data.getUint16 or even
                    // TextDecoder to process raw data bytes.
                    for (let i = 0; i < value.byteLength; i++) {
                        a.push('0x' + ('00' + value.getUint8(i).toString(16)).slice(-2));
                    }
                    //this.log('> ' + a.join(' '));
                    // console.log(a);
                    if(a[1] == "0x20")
                    {
                        //double surface = a[4] * 256 + a[3]/10.0;
                        // console.log(parseInt(a[6], 16));
                        let val1 = parseInt(a[6], 16);
                        let val2 = parseInt(a[5], 16);
                        let bodytmp = (parseInt(a[6], 16) * 256 + parseInt(a[5], 16))/10.0;
                        //double room = a[8] * 256 + a[7]/10.0;

                        // this.studentList.forEach(m => {
                        //     if (m.checked) {
                        //         m.bodyTemp = bodytmp;
                        //     }
                        // });

                        this.studTemp = bodytmp;
                        this.log('> temp reading:' + bodytmp);
                        // console.log(this.studentList, "temp");

                        // if (this.studTemp !== "") {
                        //     this.saveStudTemp();
                        // }
                    }
                }



            },
            onDisconnected(e) {
                let device = event.target;
                this.log('Device ' + device.name + ' is disconnected.');
                console.log('Device ' + device.name + ' is disconnected.');
            },
            log() {
                var line = Array.prototype.slice.call(arguments).map(function(argument) {
                    return typeof argument === 'string' ? argument : JSON.stringify(argument);
                }).join(' ');

                document.querySelector('#log').textContent += line + '\n';

                $('#output-panel').show();
            },
            clearLog() {
                document.querySelector('#log').textContent = '';
                $('#output-panel').hide();
            },
            setStatus(status) {
                document.querySelector('#status').textContent = status;
                $('#output-panel').show();
            },
            setContent() {
                var content = document.querySelector('#content');
                while (content.hasChildNodes()) {
                    content.removeChild(content.lastChild);
                }
                content.appendChild(newContent);

                $('#output-panel').show();
            },

            async checkThermoStatus() {
                if (this.thermometerStatus === true) {
                    // await this.getDevices();
                    await this.startDevicesNotif();
                } else {
                    // await this.onDisconnectButtonClick();
                    await this.stopDevicesNotif();
                }

                // if (this.thermometerStatus === "connect") {
                //     await this.getDevices();
                // } else {
                //     await this.onDisconnectButtonClick();
                // }
            },
            async connectDevices() {
                return await this.bluetoothDevice.gatt.connect();
            },
            onDisconnectButtonClick() {
                if (!this.bluetoothDevice) {
                    return;
                }
                // this.log('Disconnecting from Bluetooth Device...');
                // console.log('Disconnecting from Bluetooth Device...');
                if (this.bluetoothDevice.gatt.connected) {
                    this.bluetoothDevice.gatt.disconnect();
                    this.devicesStatusMsg = "Thermometer Scanner is disconnect!";
                } else {
                    // this.log('> Bluetooth Device is already disconnected');
                    console.log('> Bluetooth Device is already disconnected');
                }
            },

            async saveStudTemp() {

                // console.log(this.studID, "id");
                // console.log(this.studName, "name");
                // console.log(this.studTemp, "temp");
                // console.log(this.userType, "type");

                if (this.studID === "") {
                    this.$notify.error({
                        title: lang('Error'),
                        message: "Student index empty!"
                    });
                    return;
                } else if (this.studName === "") {
                    this.$notify.error({
                        title: lang('Error'),
                        message: "Student name empty!"
                    });
                    return;
                } else if (this.studTemp === "") {
                    this.$notify.error({
                        title: lang('Error'),
                        message: "Student temperature empty!"
                    });
                    return;
                } else if (this.userType === "") {
                    this.$notify.error({
                        title: lang('Error'),
                        message: "In or out empty!"
                    });
                    return;
                }

                try {
                    const response = await DataSource.shared.updateAttendanceListWithTemperatureNew("Individual Scan", this.studID, this.studTemp, this.userType, this.studRemark);
                    if (response) {

                        if (response.code === '2') {
                            this.$notify.error({
                                title: lang('Error'),
                                message: lang('Error! Please try again later')
                            });
                        } else if (response.code === '99') {
                            this.$notify.error({
                                title: lang('Error'),
                                message: lang('Error! Please try again later')
                            });
                        } else {
                            this.allStudentList.forEach(m => {
                                if (m.Index_No === this.studID) {
                                    m.tempIn = this.studTemp;
                                    m.timeTempIn = moment().format("HH:mm:ss");
                                }
                            });
                            this.$forceUpdate();

                            this.$notify({
                                title: lang('Success'),
                                message: lang('Successfully saved'),
                                type: 'success'
                            });

                            this.studID = "";
                            this.studName = "";
                            this.studTemp = "";
                            this.selectedStudent = "";
                        }
                    }
                } catch (e) {
                    this.results = e;
                }
                this.$vs.loading.close();
            },

            onlyNumber(e) {
                // var a = [];
                // var k = e.which;
                //
                // for (var i = 48; i < 58; i++)
                //     a.push(i);
                //
                // if (!(a.indexOf(k)>=0))
                //     e.preventDefault();

                var evt = (e) ? e : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();;
                } else {
                    return true;
                }
            },

            async getSpecificStudent(stud_index, stud_status) {
                if (stud_index === "") {
                    this.$notify.error({
                        title: lang('Error'),
                        message: "Student index empty!"
                    });
                    return;
                }

                if (this.allStudentList.length > 0) {
                    this.allStudentList.forEach(m => {
                        if (m.Index_No === stud_index) {
                            this.studID = m.Index_No;
                            this.studName = m.First_Name + ' ' + m.Middle_Name + ' ' + m.Last_Name;
                            this.showScanDetailsModal();
                        }
                    });
                }

                // this.$vs.loading();

                // stud_index = "SG-016-16-0037";
                // stud_status = "Active";

                // try {
                //     const response = await DataSource.shared.getStudentNew(stud_index, stud_status);
                //     if (response) {
                //
                //         if (response.code === '2') {
                //             console.log(response.code);
                //         } else if (response.code === '99') {
                //             this.$notify.error({
                //                 title: lang('Error'),
                //                 message: lang('Error! Please try again later')
                //             });
                //         } else {
                //             response.Table.forEach(m => {
                //                 this.studID = m.Index_No;
                //                 this.studName = m.Full_Name;
                //             });
                //         }
                //     }
                //     this.$vs.loading.close();
                // } catch (e) {
                //     this.results = e;
                // }
                // this.$vs.loading.close();
            },

            onWindowLoad() {
                let selectedDeviceId;
                const codeReader = new ZXing.BrowserMultiFormatReader();
                console.log('ZXing code reader initialized');
                codeReader.listVideoInputDevices()
                    .then((videoInputDevices) => {
                        const sourceSelect = document.getElementById('sourceSelect');
                        selectedDeviceId = videoInputDevices[0].deviceId;
                        if (videoInputDevices.length >= 1) {
                            videoInputDevices.forEach((element) => {
                                const sourceOption = document.createElement('option');
                                sourceOption.text = element.label;
                                sourceOption.value = element.deviceId;
                                sourceSelect.appendChild(sourceOption);
                            });

                            sourceSelect.onchange = () => {
                                selectedDeviceId = sourceSelect.value;
                            };

                            const sourceSelectPanel = document.getElementById('sourceSelectPanel');
                            sourceSelectPanel.style.display = 'block';
                        }

                        document.getElementById('startButton').addEventListener('click', () => {
                            codeReader.decodeFromVideoDevice(selectedDeviceId, 'video', (result, err) => {
                                if (result) {
                                    // console.log(result);
                                    alert(result);
                                    this.scanStudIndex = result.text;
                                    this.selectedStudent = result.text;
                                    this.getSpecificStudent(this.scanStudIndex, "Active");
                                    document.getElementById('result').textContent = result.text;
                                }
                                if (err && !(err instanceof ZXing.NotFoundException)) {
                                    console.error(err);
                                    this.$notify.error({
                                        title: lang('Error'),
                                        message: lang('Error! Please try again later')
                                    });
                                    document.getElementById('result').textContent = err;
                                }
                            });
                            console.log(`Started continous decode from camera with id ${selectedDeviceId}`);
                        });

                        // document.getElementById('resetButton').addEventListener('click', () => {
                        //     codeReader.reset();
                        //     document.getElementById('result').textContent = '';
                        //     console.log('Reset.');
                        // });

                    })
                    .catch((err) => {
                        console.error(err);
                    });
            },

            async getAllStudent() {
                this.$vs.loading();

                try {
                    // const response = await DataSource.shared.getAllActiveStudentsBySchoolWithMode("Dashboard");
                    const response = await DataSource.shared.getAllActiveStudentsBySchoolWithMode("ProfileImagePhysicalPath");
                    if (response) {

                        if (response.code === '2') {
                            console.log(response.code);
                        } else if (response.code === '88') {
                            window.location.replace('/');
                        } else if (response.code === '99') {
                            this.$notify.error({
                                title: lang('Error'),
                                message: lang('Error! Please try again later')
                            });
                        } else {
                            response.Table.forEach((resp, respIndex) => {
                                resp.fullName = resp.First_Name + resp.Middle_Name + resp.Last_Name;
                            });

                            await this.groupStudentList(response.Table);
                            // this.groupStudentList(response.Table);
                            this.allStudentList = response.Table;
                            this.filterAllStudentList = this.allStudentList;
                        }

                        // this.groupStudentList(this.allStudentList);
                        // console.log(this.groupAllStudentList, "group all list");
                    }
                    this.$vs.loading.close();
                } catch (e) {
                    this.results = e;
                }
                this.$vs.loading.close();
            },

            changeStudent(studIndexNo) {
                this.scanStudIndex = studIndexNo;
                this.getSpecificStudent(this.scanStudIndex, "Active");
            },

            triggerStartClick() {
                var start = document.getElementById('startButton');
                start.click();
            },

            checkBarcodeStatus() {
                if (this.barcodeStatus === "start") {
                    this.triggerStartScan();
                } else {
                    this.triggerStopScan();
                }
            },

            triggerStartScan() {
                if (navigator.mediaDevices && typeof navigator.mediaDevices.getUserMedia === 'function') {
                    let self = this;

                    Quagga.init({
                        inputStream : {
                            type : "LiveStream",
                            constraints: {
                                width: {min: 1280},
                                height: {min: 720},
                                aspectRatio: {min: 1, max: 100},
                                facingMode: "environment" // or user
                            }
                        },
                        decoder : {
                            readers : ["code_39_reader"]
                        },
                        numOfWorkers: 0,
                        frequency: 10,
                        locate: true,
                        locator: {
                            patchSize: "x-small",
                            halfSample: true
                        }
                    }, function(err) {
                        if (err) {
                            console.log(err);
                            return
                        }
                        console.log("Initialization finished. Ready to start");
                        self.initCameraSelection();
                        Quagga.start();
                    });


                    Quagga.onProcessed(function(result) {
                        var drawingCtx = Quagga.canvas.ctx.overlay,
                            drawingCanvas = Quagga.canvas.dom.overlay;

                        if (result) {
                            if (result.boxes) {
                                drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute("width")), parseInt(drawingCanvas.getAttribute("height")));
                                result.boxes.filter(function (box) {
                                    return box !== result.box;
                                }).forEach(function (box) {
                                    Quagga.ImageDebug.drawPath(box, {x: 0, y: 1}, drawingCtx, {color: "green", lineWidth: 2});
                                });
                            }

                            if (result.box) {
                                // Quagga.ImageDebug.drawPath(result.box, {x: 0, y: 1}, drawingCtx, {color: "#00F", lineWidth: 2});
                            }

                            if (result.codeResult && result.codeResult.code) {
                                // Quagga.ImageDebug.drawPath(result.line, {x: 'x', y: 'y'}, drawingCtx, {color: 'red', lineWidth: 3});
                            }
                        }
                    });

                    Quagga.onDetected(function(result) {
                        var code = result.codeResult.code;

                        console.log(code);
                        self.scanStudIndex = code;
                        self.selectedStudent = code;
                        self.studTemp = "";
                        self.getSpecificStudent(self.scanStudIndex, "Active");

                        // if (App.lastResult !== code) {
                        //     App.lastResult = code;
                        //     var $node = null, canvas = Quagga.canvas.dom.image;
                        //
                        //     $node = $('<li><div class="thumbnail"><div class="imgWrapper"><img /></div><div class="caption"><h4 class="code"></h4></div></div></li>');
                        //     $node.find("img").attr("src", canvas.toDataURL());
                        //     $node.find("h4.code").html(code);
                        //     $("#result_strip ul.thumbnails").prepend($node);
                        // }
                    });
                }

                // Quagga.start();
            },

            triggerStopScan() {
                Quagga.stop();
            },

            initCameraSelection() {
                var streamLabel = Quagga.CameraAccess.getActiveStreamLabel();

                return Quagga.CameraAccess.enumerateVideoDevices()
                    .then(function(devices) {
                        function pruneText(text) {
                            return text.length > 30 ? text.substr(0, 30) : text;
                        }
                        var $deviceSelection = document.getElementById("deviceSelection");
                        while ($deviceSelection.firstChild) {
                            $deviceSelection.removeChild($deviceSelection.firstChild);
                        }
                        devices.forEach(function(device) {
                            var $option = document.createElement("option");
                            $option.value = device.deviceId || device.id;
                            $option.appendChild(document.createTextNode(pruneText(device.label || device.deviceId || device.id)));
                            $option.selected = streamLabel === device.label;
                            $deviceSelection.appendChild($option);
                        });
                    });
            },

            showScanDetailsModal() {
                this.$refs.modal_ScanDetails.show();
            },

            hideScanDetailsModal() {
                this.$refs.modal_ScanDetails.hide();

                this.studID = "";
                this.studName = "";
                this.studTemp = "";
                this.selectedStudent = "";
            },

            groupStudentList (result) {
                let sortedList = this.groupBy(result, "SMT_Code", "SMT_Code");

                for (let i = 0; i < sortedList.length; i++) {
                    let tempLevel = this.groupBy(sortedList[i].ArrObj_Items, "CRS_Course_Name", "CRS_Course_Name");

                    for (let j = 0; j < tempLevel.length; j++) {
                        let tempClass = this.groupBy(tempLevel[j].ArrObj_Items, "PK_Class_ID", "CLS_ClassName");

                        tempLevel[j].ArrObj_Items = tempClass;
                    }

                    sortedList[i].ArrObj_Items = tempLevel;
                }

                this.groupAllStudentList = sortedList;
            },

            /*#region Array Grouping Function*/
            groupBy(data, key, display) {
                let ArrObj_Sorted = [];
                let arrstr_display = !this.isNull(display) ? display.split(",") : [key];

                for (let item of data) {
                    let index = ArrObj_Sorted.findIndex(x => x.Str_SortBy === item[key]);
                    
                    if (index === -1) {
                        let str_Display = "";
                        for (let tempdisp of arrstr_display)
                        {
                            if (display === "CLS_ClassName") {
                                str_Display += item[tempdisp] + " " + "( "+item["CLS_Batch"]+" )";
                            } else {
                                str_Display += item[tempdisp] + " ";
                            }
                        }
                        
                        ArrObj_Sorted.push({Str_SortBy: item[key], Str_Display: str_Display, ArrObj_Items: [item]});
                    } else
                        ArrObj_Sorted[index].ArrObj_Items.push(item);
                }

                return ArrObj_Sorted;
            },
            /*#endregion*/

            replaceStringSpace(val) {
                return val.replace(/ /g, "");
            },

            getSource(obj) {
                let imgsrc = "";
                if (obj.Profile_Img == null || obj.Profile_Img == "")
                    imgsrc = "data:image/png;base64,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";
                else
                    imgsrc = obj.Profile_Img;
                // imgsrc = "data:" + obj.Profile_ImgType + ";base64," + obj.Profile_Img;
                return imgsrc;
            },

            async getStudentWithClass() {
                const response = await DataSource.shared.LoadAttendanceListWithMode(this.ddlClass, 'GroupClasName');
                if (response) {

                    if (response.code === '2') {

                    } else if (response.code === '99') {
                        this.$notify.error({
                            title: lang('Error'),
                            message: lang('Error! Please try again later')
                        });
                    } else {

                        // this.studentList.forEach(m => {
                        //     m.checked = false;
                        // });
                        //
                        // this.studentList = response.Table;
                    }
                }
            },


            onDecode (result) {
                // this.result = result

                this.scanStudIndex = result;
                this.selectedStudent = result;
                this.studTemp = "";
                this.getSpecificStudent(this.scanStudIndex, "Active");
            },

            async onInit (promise) {
                try {
                    await promise
                } catch (error) {
                    if (error.name === 'NotAllowedError') {
                        this.$notify.error({
                            title: lang('Error'),
                            message: "ERROR: you need to grant camera access permisson"
                        });
                    } else if (error.name === 'NotFoundError') {
                        this.$notify.error({
                            title: lang('Error'),
                            message: "ERROR: no camera on this device"
                        });
                    } else if (error.name === 'NotSupportedError') {
                        this.$notify.error({
                            title: lang('Error'),
                            message: "ERROR: secure context required (HTTPS, localhost)"
                        });
                    } else if (error.name === 'NotReadableError') {
                        this.$notify.error({
                            title: lang('Error'),
                            message: "ERROR: is the camera already in use?"
                        });
                    } else if (error.name === 'OverconstrainedError') {
                        this.$notify.error({
                            title: lang('Error'),
                            message: "ERROR: installed cameras are not suitable"
                        });
                    } else if (error.name === 'StreamApiNotSupportedError') {
                        this.$notify.error({
                            title: lang('Error'),
                            message: "ERROR: Stream API is not supported in this browser"
                        });
                    }
                }
            },

            searchStudent() {
                this.filterAllStudentList = this.allStudentList.filter(x => x.fullName.toLowerCase().includes(this.searchValue));
                // this.groupAllStudentList = this.allStudentList.filter(x => x.fullName.toLowerCase().includes(this.searchValue));
            },

            showSearch() {
                if (this.isSearch === true) {
                    this.isSearch = false;
                } else {
                    this.isSearch = true;
                }
            },

            isMobile() {
                let screenWidth = window.innerWidth;
                this.screenWidth = screenWidth;
                if (screenWidth <= 770) {
                    this.checkMobileStatus = true;
                } else {
                    this.checkMobileStatus = false;
                }
            },

            isNull(obj) {
                return (obj === null || obj === undefined || obj === "undefined" || obj.length === 0 || obj === "");
            },
        },
        destroyed () {
            window.removeEventListener('resize', this.isMobile);
        },
        watch: {

        },
    }
</script>

<style scoped>
    .student-search {
        background-image: url('../assets/Vector23.png')!important;
        background-position: 95% center!important;
        background-repeat: no-repeat!important;
        width: 100%;
        font-size: 16px;
        padding: 0.375rem 40px 0.375rem 0.75rem;
    }

    .student-search::placeholder {
        color: #91A3B6;
        font-size: 12px;
    }

    .student-each-container {
        text-align: left;
        border-bottom: 1px solid #D3D9E8;
        padding: 5px;
        cursor: pointer;
    }

    .student-tag .div_Student {
        position: relative;;
    }

    .sct-ipad .student-tag .div_Student {
        width: calc(25% - 10px);
    }

    .sct-mobile .student-tag .div_Student {
        width: calc(50% - 10px);
    }
</style>